export const SEND_TYPING_MESSAGE_THROTTLE_MS = 3000;